module.exports = "build/assets/education.20b03e03.png";